export default "__VITE_ASSET__DBx_QNPC__"